/**
 * Header search panel.
 *
 *   - SEARCH button (data-tx-search-toggle) opens/closes the panel.
 *   - ⌘K / Ctrl+K toggles from anywhere on the page.
 *   - Esc key, the ESC button, or click-outside all close the panel.
 *   - Focus moves into the input on open and back to the toggle on close.
 *
 * Panel stays in the DOM (no display:none) so CSS can animate opacity
 * and transform. aria-hidden tracks open state for assistive tech.
 */
const init = () => {
    const panel  = document.getElementById('tx-hdr-search');
    const toggle = document.querySelector('[data-tx-search-toggle]');
    if (!panel || !toggle) return;

    const input    = panel.querySelector('input[name="s"]');
    const closeBtn = panel.querySelector('[data-tx-search-close]');

    const isOpen = () => panel.classList.contains('is-open');

    const setOpen = (open) => {
        panel.classList.toggle('is-open', open);
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('tx-hdr-search-open', open);

        if (open) {
            if (input) {
                input.removeAttribute('tabindex');
                requestAnimationFrame(() => input.focus());
            }
        } else {
            input?.setAttribute('tabindex', '-1');
            toggle.focus({ preventScroll: true });
        }
    };

    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(!isOpen());
    });

    closeBtn?.addEventListener('click', () => setOpen(false));

    document.addEventListener('keydown', (e) => {
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
            e.preventDefault();
            setOpen(!isOpen());
            return;
        }
        if (e.key === 'Escape' && isOpen()) {
            e.preventDefault();
            setOpen(false);
        }
    });

    document.addEventListener('click', (e) => {
        if (!isOpen()) return;
        if (panel.contains(e.target) || toggle.contains(e.target)) return;
        setOpen(false);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
